import { render, staticRenderFns } from "./banUserList.vue?vue&type=template&id=be8149e8&scoped=true&"
import script from "./banUserList.vue?vue&type=script&lang=js&"
export * from "./banUserList.vue?vue&type=script&lang=js&"
import style0 from "./banUserList.vue?vue&type=style&index=0&id=be8149e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8149e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be8149e8')) {
      api.createRecord('be8149e8', component.options)
    } else {
      api.reload('be8149e8', component.options)
    }
    module.hot.accept("./banUserList.vue?vue&type=template&id=be8149e8&scoped=true&", function () {
      api.rerender('be8149e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/banUser/banUserList.vue"
export default component.exports